<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar etapa" col-md="col-md-5"
             offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('descricao')" autofocus/>
                <label for="descricao"><strong>Descrição: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="tempo" v-model="dado.tempo" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('tempo')"/>
                <label for="tempo"><strong>Tempo (Dias): <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Textarea id="descritivo" v-model="dado.descritivo" rows="2" cols="100"/>
                <label for="descritivo"><strong>Descritivo: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "EditarEtapa",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.etapas.retrieveUpdateDestroy(this.itemKey));
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      const resultado = await apiRequest("PATCH", apiUrl.etapas.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
